<div class="_impact-count-statistic-component">

    <div class="_period-selector-container">
        <div class="_period-container" [ngClass]="{'_active': selectedPeriod === periods[0]}" (click)="onPeriodFilter(periods[0])">
            <span class="_period">{{'STATISTICS.IMPACT.PERIODS.1' | translate}}</span>
        </div>
        <div class="_period-container" [ngClass]="{'_active': selectedPeriod === periods[1]}" (click)="onPeriodFilter(periods[1])">
            <span class="_period">{{'STATISTICS.IMPACT.PERIODS.2' | translate}}</span>
        </div>
    </div>

    <div class="_impact-statistics-container">
        <div class="_impact-count">
            <ion-icon src="./assets/icons/clients-outline.svg"></ion-icon>
            <p innerHTML="{{'STATISTICS.IMPACT.TOTAL' | translate:{count: counts?.total ?? 0} }}"></p>
        </div>
    
        <div class="_impact-count">
            <ion-icon src="./assets/icons/education-outline.svg"></ion-icon>
            <p innerHTML="{{'STATISTICS.IMPACT.EDUCATIONS' | translate:{count: counts?.educations ?? 0} }}"></p>
        </div>
    
        <div class="_impact-count">
            <ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
            <p innerHTML="{{'STATISTICS.IMPACT.ESSENTIAL_SERVICES' | translate:{count: counts?.essentialServices ?? 0} }}"></p>
        </div>
    
        <div class="_impact-count">
            <ion-icon src="./assets/icons/device-outline.svg"></ion-icon>
            <p innerHTML="{{'STATISTICS.IMPACT.LOANS' | translate:{count: counts?.loans ?? 0} }}"></p>
        </div>
    </div>
	
</div>



